import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const uploadFilesStyle = (theme) => ({
	smallTab: ({ margins }) => ({
		width: margins ? '70%' : '100%',
		maxWidth: '624px',
		margin: '0 auto',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	}),
	tab: ({ margins }) => ({
		marginTop: '24px',
		padding: margins ? '24px' : '0px',
		minHeight: margins ? '640px' : '200px',
		display: margins ? 'block' : 'table',
		backgroundColor: whiteColor,
		borderRadius: '8px 8px 0 0',
	}),
	uploadWrapper: ({ margins }) => ({
		padding: margins ? '50px' : '0px',
		[theme.breakpoints.down('xs')]: {
			padding: 0,
		},
	}),
	allowedFormats: {
		margin: '8px 0 8px 0',
	},
	uploadProofFiles: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
	},
	errorBox: {
		marginTop: '10px',
	},
	fileUploadHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: '14px !important',
		marginTop: '28px',
	},
	downloadLink: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg': {
			position: 'relative',
			bottom: '2px',
			marginRight: '4px',
		},
	},
});

export default uploadFilesStyle;
